






































































import { Component, Vue, Prop, Watch, State, namespace, Getter } from 'nuxt-property-decorator'
import debounce from 'lodash/debounce'
import { IconClose } from '@klook/klook-icons'
import { CancelTokenSource } from 'axios'
import SuggestRecommend from './recommend.vue'
import SearchResult from '~/components/tour/home/search-keywords-result/index.vue'
import apiNameMap from '~/share/data/apis'
import { formatHistoryDestination, parseParamsId } from '~/components/tour/tour-base/utils'
import eventBus from '~/pages/experience/pay/common/event-bus'
import { isExperienceEndPath, isChromeOrSafari } from '~/share/utils'
import { recordSearchHistory } from '~/components/tour/destination-search/utils'
import { ExpSearchSkeleton } from '~/components/common/skeleton-data/index.js'

const experience = namespace('experience')

@Component({
  components: {
    SuggestRecommend,
    SearchResult,
    IconClose
  }
})
export default class TourHomeMobileDestinationSearch extends Vue {
  @State(state => state.klook.platform) platform!: Data.Platform
  @Getter languagePath!: string
  @experience.State suggestion!: any
  @experience.State filterKeywords!: string
  @experience.State notCalDestination!: number

  @Prop({ type: Boolean, default: true }) showSearchInput!: boolean
  @Prop({ type: String, default: '' }) customKeywords!: string
  @Prop({ default: false }) visible!: boolean

  ExpSearchSkeleton = ExpSearchSkeleton
  keywords: string = ''
  showLoading: boolean = false
  showContent: boolean = false
  search_placeholder: string = ''
  hasSearchResult: boolean = false
  cancelToken!: CancelTokenSource
  cacheSearchResult = new Map() // 缓存搜索结果

  suggestInfo: any = {
    list: [],
    current_destination: {}
  }

  searchResult: any = {
    list: [],
    suggest_destinations: []
  }

  handleKeyWordChange = debounce(this.getSearchResult, 400)

  get isDesktop() {
    return this.platform === 'desktop'
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (process.client && val) {
      if (this.showSearchInput) {
        this.init()
      } else {
        this.handleKeyWordChange()
      }

      this.$nextTick(() => {
        this.checkBrowser()
      })
    }
  }

  @Watch('customKeywords')
  onCustomKeywordsChange(val: string) {
    if (process.client && !this.showSearchInput) {
      if (val) {
        this.handleKeyWordChange()
      } else {
        this.hasSearchResult = false
        this.getSuggesInfo()
      }
    }
  }

  handleRendered() {
    this.showLoading = false

    !this.showContent && (this.showContent = true)
  }

  genCityIdAndCountryId() {
    const { frontendId = '', cityId = '', countryId = '', pid = '', tagId = '' } = parseParamsId(this.$route.params)
    // 推荐目的地也要加上
    const { country_id: suggestCountryId, city_id: suggestCityId, poi_id: suggestPoiId = '' } = this.suggestion

    return {
      frontendId,
      city_id: cityId || (suggestCityId > 0 ? suggestCityId : ''),
      country_id: countryId || (suggestCountryId > 0 ? suggestCountryId : ''),
      pid: pid || (suggestPoiId > 0 ? suggestPoiId : ''),
      tagId
    }
  }

  genCancelToken() {
    const CancelToken = this.$axios.CancelToken
    return CancelToken.source()
  }

  async getSuggesInfo() {
    if (!this.visible || this.suggestInfo.list.length) { return }

    this.showLoading = true

    const cache_history_destinations = this.$cookies.get('TNAHD') || ''
    const format_history_destinations = formatHistoryDestination(cache_history_destinations)

    const params: any = {
      history_destinations: format_history_destinations
    }

    const { city_id, country_id, pid, tagId } = this.genCityIdAndCountryId()

    if (city_id) {
      params.city_id = Number(city_id)
    }

    if (country_id) {
      params.country_id = Number(country_id)
    }

    if (pid) {
      params.poi_id = Number(pid)
    }

    if (tagId) {
      params.tag_id = Number(tagId)
    }

    try {
      const { success, result } = await this.$axios.$post(
        apiNameMap.getSuggestDestinationV2,
        params
      )

      if (success && result) {
        const {
          basic: { search_placeholder = '' },
          current_destination = {}
        } = result || {}

        if (result?.list) {
          this.suggestInfo.list = result.list
        } else {
          this.showContent = true
          this.showLoading = false
        }

        this.suggestInfo.current_destination = current_destination
        this.search_placeholder = search_placeholder
      }
    } catch (error) {
      this.showLoading = false
    }
  }

  async getSearchResult() {
    if (!this.visible) { return }

    const combineKeywords = this.keywords || this.customKeywords

    if (!combineKeywords) {
      this.hasSearchResult = false

      if (this.suggestInfo.list.length === 0) {
        this.showLoading = true
        this.showContent = false
        this.getSuggesInfo()
      }

      return
    }

    if (this.cacheSearchResult.has(combineKeywords)) {
      const res = this.cacheSearchResult.get(combineKeywords)

      // 有结果才走缓存。没有结果就重新去请求
      if (res) {
        this.showContent = true
        this.hasSearchResult = true
        this.searchResult = this.cacheSearchResult.get(combineKeywords)
        return
      }
    }

    if (this.cancelToken) {
      this.cancelToken.cancel('cancel')
    }

    !this.showContent && (this.showLoading = true)

    this.cancelToken = this.genCancelToken()

    try {
      const { frontendId, city_id, country_id, pid } = this.genCityIdAndCountryId()
      const { success, result } = await this.$axios.$get(
        apiNameMap.searchSuggestDestinationResultV2,
        {
          params: {
            keyword: this.keywords || this.customKeywords,
            frontend_id_list: frontendId,
            city_id,
            country_id,
            poi_id: pid
          },
          cancelToken: this.cancelToken?.token
        }
      )
      this.showLoading = false

      if (success && result) {
        this.searchResult = result
        this.cacheSearchResult.set(combineKeywords, result)
      } else {
        this.resetSearchResult()
      }

      this.hasSearchResult = !!result
      this.showContent = true
    } catch (error) {
      this.showLoading = false
    }
  }

  resetSearchResult() {
    this.searchResult = {
      list: [],
      suggest_destinations: []
    }
  }

  handleClick() {
    setTimeout(() => {
      this.$inhouse.track('action', (this.$refs.searchInput as any)?.$el, { force: true })
    }, 100)
  }

  handleClose() {
    eventBus.$emit('closeFullScreenModal')
  }

  handleClear() {
    if (!this.keywords) { return }

    this.keywords = ''
    this.showContent = false
    this.getSuggesInfo()
  }

  handleKeyDown(e: any) {
    if (e.keyCode === 13 && this.keywords && this.showSearchInput) {
      let url = `${this.languagePath}/experiences/list/`
      const isHomePage = isExperienceEndPath(this.$route.path)

      if (isHomePage) {
        url += `?keywords=${this.keywords}&not_cal_destination=1`
      } else {
        const { city_id, country_id, pid } = this.genCityIdAndCountryId()
        const { seoLink = '' } = this.$route.params || {}
        const formatSeo = `${seoLink || '-'}`

        if (city_id) {
          url += `${formatSeo}/c${city_id}`
        }

        if (country_id) {
          url += `${formatSeo}/g${country_id}`
        }

        if (pid) {
          url += `${formatSeo}/p${pid}`
        }

        if (city_id || country_id || pid) {
          // 补全路由，减少一次跳转
          url += '/'
        }

        url += `?keywords=${this.keywords}`

        if (this.notCalDestination) {
          url += `&not_cal_destination=${this.notCalDestination}`
        }
      }

      recordSearchHistory(this.keywords, url)
      window.location.href = this.$href(url)

      this.$inhouse.track('custom', 'body', {
        spm: 'TNA_SearchStart.TNASearchEnterKeyboard',
        ext: {
          query: this.keywords
        }
      })
    }
  }

  init() {
    const keywords = this.filterKeywords || ''

    if (keywords) {
      this.keywords = keywords
      this.hasSearchResult = true
      this.getSearchResult()
    }

    if (!this.keywords) {
      this.getSuggesInfo()
    }
  }

  handleClearFilterKeywords() {
    this.keywords = ''
    this.hasSearchResult = false
    this.resetSearchResult()
  }

  checkBrowser() {
    const isChromeOrSafariBrowser = !this.isDesktop && isChromeOrSafari()

    if (isChromeOrSafariBrowser && this.$el) {
      const target = this.$el as HTMLElement

      !target.classList.contains('is-special-browser') && target.classList.add('is-special-browser')
    }
  }

  mounted() {
    eventBus.$on('clearAllQuickFilters', this.handleClearFilterKeywords)
  }

  beforeDestroy() {
    eventBus.$off('clearAllQuickFilters')
  }
}
